<template>
  <div id="about-us">
    <div style="position: relative; top: 0; left: 0;">
      <div
        :style="{
          height: `${phoneSearchHeight}px`
        }"
      />
      <Banner ref="banner" :banner-cat-id="11" class="banner" />
      <MyCould />
    </div>
    <div class="about-us-content">
      <el-row class="about-us-content-box">
        <el-col
          v-show="innerWidthType !== 'xs' && innerWidthType !== 'sm'"
          :span="4"
          class="side-bar-container"
        >
          <sideBar
            class="side-bar"
            :style="{ top: `${topHeight}px` }"
            @commonFun="getArticleContent"
          />
        </el-col>
        <el-col :xs="22" :sm="22" :md="18" :lg="18" :xl="18">
          <div
            v-if="searchData.id === 22 || searchData.id === 23"
            class="content-container"
          >
            <div class="container-title">
              {{ title }}
            </div>
            <el-col v-if="articleCare" class="content-care" style="flex-wrap: wrap;">
              <el-col
                v-for="(item, index) in articleCare"
                :key="index"
                :xs="22"
                :sm="22"
                :md="7"
                :lg="7"
                :xl="7"
              >
                <div
                  style="position: relative; left: 0; top: 0; margin-bottom: 5%;"
                >
                  <i
                    v-if="searchData.id === 23"
                    class="iconfont ico-rongyu ld-icon"
                  />
                  <el-image
                    ref="ldImages"
                    class="ld-images"
                    :src="item.url"
                    :preview-src-list="articleCareList"
                    :z-index="index"
                    :style="{
                      background: searchData.id === 23 ? '#fff' : '',
                      'border-bottom-left-radius':
                        searchData.id === 23 ? '0' : '15px',
                      'border-bottom-right-radius':
                        searchData.id === 23 ? '0' : '15px'
                    }"
                    lazy
                  />
                  <div
                    ref="ldInfo"
                    class="content-care-info"
                    :style="{
                      background: searchData.id === 23 ? '#fff' : '',
                      'border-top-left-radius':
                        searchData.id === 23 ? '0' : '15px',
                      'border-top-right-radius':
                        searchData.id === 23 ? '0' : '15px'
                    }"
                  >
                    <div ref="ldInfoFont">{{ item.name }}</div>
                  </div>
                </div>
              </el-col>
            </el-col>
          </div>

          <div v-else-if="searchData.id === 25" class="content-container">
            <div class="container-title">
              {{ title }}
            </div>
            <el-timeline class="container-time-line">
              <el-timeline-item
                v-for="(item, index) in articleData"
                :key="index"
                :timestamp="item.description"
                placement="top"
              >
                <div>
                  <div v-html="item.content" />
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>

          <div v-else-if="total === 1" class="content-container">
            <div class="container-title">
              {{ title }}
            </div>
            <div class="container-detail" v-html="articleDetail.content" />
          </div>

          <div v-if="this.$route.query.id" class="content-container">
            <div class="info-title">{{ articleInfoDetail.title }}</div>
            <div class="info-time-source">
              <div class="info-time">
                发布时间：{{ articleInfoDetail.submit_time }}
              </div>
              <div class="info-source">
                来源：{{ articleInfoDetail.source }}
              </div>
            </div>
            <div class="info-detail" v-html="articleInfoDetail.content" />
          </div>

          <div
            v-else-if="
              total > 1 &&
                searchData.id !== 25 &&
                searchData.id !== 22 &&
                searchData.id !== 23
            "
            class="content-container"
          >
            <div class="container-title">{{ title }}</div>
            <div v-if="total !== 0" class="content">
              <div
                v-for="(item, index) in articleData"
                :key="index"
                class="content-item"
                @click="goDetail(item)"
              >
                <div class="content-item-title">{{ item.description }}</div>
                <div class="content-item-time">{{ item.submit_time }}</div>
              </div>
            </div>
            <div v-else class="tips">
              <img
                :src="require('@/assets/images/noData.png')"
                alt="暂无数据"
                ondragstart="return false;"
              >
            </div>
          </div>
          <el-pagination
            v-if="total > 10 && searchData.id !== 25"
            class="page"
            layout="prev, pager, next"
            :page-size="searchData.limit"
            :total="searchData.page"
            :current-page.sync="searchData.page"
            @current-change="handleCurrentChange"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import API from '@/api/service'
import sideBar from '@/components/sideBar'

export default {
  name: 'AboutUs',
  components: {
    sideBar
  },
  data() {
    return {
      innerWidthType: '',
      articleCare: [],
      articleCareList: [],
      articleInfoDetail: {},
      ldImagesHeight: 0,
      ldInfoHeight: 0,
      articleData: [],
      articleDetail: {},
      isShowCould: false,
      parent_id: '',
      searchData: {
        id: '',
        limit: 10,
        page: 1
      },
      showBanner: false,
      topHeight: 0,
      total: 0,
      title: '',
      titleFont: {
        17: '合作加盟',
        18: '栽培基地',
        19: '和顺本草',
        20: '公司简介',
        21: '总裁致辞',
        22: '领导关怀',
        23: '资质荣誉',
        24: '和顺文化',
        25: '发展历程',
        26: '联系我们'
      },
      phoneSearchHeight: 0,
      timesLimit: 0
    }
  },
  watch: {
    $route(newVal, oldVal) {
      this.articleCare = []
      this.articleCareList = []
      const bannerTop = document.querySelector('.banner').clientHeight
      document.body.scrollTop = bannerTop
      document.documentElement.scrollTop = bannerTop
      this.searchData = {
        id: '',
        limit: 10,
        page: 1
      }
      this.ldInfoHeight = 0
      this.searchData.id = Number(this.$route.params.id)
      if (this.searchData.id !== 23) {
        this.ldImagesHeight = 0
      }
      this.getArticleContent(this.$route.params.id)
    }
  },
  mounted() {
    this.showBanner = true
    this.parent_id = this.$route.params.parent_id
    this.searchData.id = Number(this.$route.params.id)
    this.getArticleContent(this.$route.params.id)
    this.getInnerWidthType()
    window.addEventListener('scroll', () => {
      this.setSideBarFix()
    })
    window.addEventListener('resize', () => {
      this.getInnerWidthType()
      this.setSideBarFix()
    })
  },
  destroyed() {
    window.removeEventListener('scroll', () => {
      this.setSideBarFix()
    })
    window.removeEventListener('resize', () => {
      this.getInnerWidthType()
      this.setSideBarFix()
    })
    this.timesLimit = 0
  },
  methods: {
    getInnerWidthType() {
      if (window.innerWidth >= 1920) {
        this.innerWidthType = 'xl'
      } else if (window.innerWidth >= 1200) {
        this.innerWidthType = 'lg'
      } else if (window.innerWidth >= 992) {
        this.innerWidthType = 'md'
      } else if (window.innerWidth > 768) {
        this.innerWidthType = 'sm'
      } else {
        this.innerWidthType = 'xs'
      }
    },
    setSideBarFix() {
      if (this.$refs.banner) {
        const bannerHeight = this.$refs.banner.$el.offsetHeight
        const bannerTop = this.$refs.banner.$el.offsetTop
        const scTop =
          document.documentElement.scrollTop || document.body.scrollTop
        const top = scTop + bannerTop
        const ofHeight =
          document.documentElement.offsetHeight || document.body.offsetHeight
        const clHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        const footerBottom = document.querySelector('#footer').clientHeight
        const sideHeight =
          document.querySelector('.side-bar-container').clientHeight -
          document.querySelector('.side-bar').clientHeight
        if (scTop > 200 && scTop < 500 && !this.isShowCould) {
          this.isShowCould = true
        }
        if (top >= bannerHeight + bannerTop) {
          this.topHeight = top - (bannerHeight + bannerTop)
        } else {
          this.topHeight = 0
        }

        if (
          sideHeight - this.topHeight < 0 &&
          footerBottom > ofHeight - scTop - clHeight
        ) {
          this.topHeight = sideHeight
        }
      }
      if (this.searchData.id === 23 && this.$refs.ldImages) {
        if (this.$refs.ldImages[0]) {
          this.ldImagesHeight = this.$refs.ldImages[0].$el.clientHeight
        }
        if (this.ldImagesHeight !== 0) {
          this.$refs.ldImages.map(item => {
            item.$el.style.height = `${this.ldImagesHeight}px`
          })
        }
      }
      if (
        (this.searchData.id === 22 || this.searchData.id === 23) &&
        this.$refs.ldInfo
      ) {
        this.$refs.ldInfoFont.map(item => {
          if (this.ldInfoHeight < item.clientHeight) {
            this.ldInfoHeight = item.clientHeight
          }
        })
        this.$refs.ldInfo.map(item => {
          item.style.height = `${this.ldInfoHeight}px`
        })
      }
    },
    getArticleContent() {
      this.searchData.id = Number(this.$route.params.id)
      this.title = this.titleFont[Number(this.searchData.id)]
      this.articleDetail = {}
      this.articleData = []
      if (this.searchData.id !== 22 && this.searchData.id !== 23) {
        if (this.$route.query.id) {
          const parms = { id: this.$route.query.id }
          API.getArticleDate(parms).then(res => {
            this.articleInfoDetail = res.data
          })
        } else {
          API.getArticleList({ ...this.searchData }).then(res => {
            this.total = res.count
            if (this.total === 1) {
              const parms = { id: this.$route.params.id, type: 1 }
              API.getArticleDate(parms).then(res => {
                this.articleDetail = res.data
              })
            } else {
              this.articleData = res.data
              if (
                this.searchData.id === 21 &&
                res.data.length &&
                this.timesLimit === 0
              ) {
                this.goDetail(res.data[0])
                this.timesLimit = 1
              }
            }
          })
        }
      } else {
        API.getBannerList({
          banner_cat_id: this.searchData.id === 22 ? 4 : 5
        })
          .then(res => {
            this.articleCare = res.data
            const data = []
            this.articleCare.map(item => {
              // data.push(item.remark ? item.remark : item.url)
              data.push(item.url)
            })
            this.articleCareList = data
          })
          .finally(() => {
            document.documentElement.scrollTop =
              document.documentElement.scrollTop + 1
            document.body.scrollTop = document.body.scrollTop + 1
          })
      }
    },
    goDetail(data) {
      this.$router.push({
        name: this.$route.name,
        params: {
          parent_id: this.$route.params.parent_id,
          id: this.$route.params.id
        },
        query: { id: data.id }
      })
    },
    handleCurrentChange(val) {
      this.searchData.page = val
      this.getArticleContent()
    },
    setHeight() {
      this.$parent.getHeightList()
    },
    setPhoneSearchHeight(data) {
      this.phoneSearchHeight = data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/aboutUs/xl.scss";
@media screen and (max-width: 1920px) {
  @import "@/assets/css/aboutUs/lg.scss";
}
@media screen and (max-width: 1200px) {
  @import "@/assets/css/aboutUs/md.scss";
}
@media screen and (max-width: 992px) {
  @import "@/assets/css/aboutUs/sm.scss";
}
@media screen and (max-width: 768px) {
  @import "@/assets/css/aboutUs/xs.scss";
}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs.vue